import { render, staticRenderFns } from "./EventSlogan.vue?vue&type=template&id=63c1a491&"
import script from "./EventSlogan.vue?vue&type=script&lang=js&"
export * from "./EventSlogan.vue?vue&type=script&lang=js&"
import style0 from "./EventSlogan.vue?vue&type=style&index=0&id=63c1a491&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports